module.exports = __webpack_public_path__ + "img/ASELogo_02.png";